const initialState = [];

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "qIncidents/clean":
      return initialState;
    case "qIncidents/store":
      return action.payload;
    default:
      return state;
  }
}
